const networks = [
    {    
        attributes: {dhcp: 'yes', delegate_type: 'asn1_delegate'},
        id: "jk1BpqnMHciyD8Ky9JUoeZ",
        name: "network1",
        type: 18
    }
]

export default networks;